import { createSlice } from '@reduxjs/toolkit';
import { signIn } from './thunk';

export interface InitialState {
  accessToken: string | null;
  refreshToken: string | null;
  roleUser?: number | string | null;
  user_name: string;
  cooperator_id: string | null;
  error_message?: string;
  kengen_code?: string;
  user_id: number | null;
  // 2023/11/7 Leading Win ログイン変更対応 start
  business_owner_flg: number | null;
  syokucyou_flg: number | null;
  // 2023/11/7 Leading Win ログイン変更対応 end
}

const initialState: InitialState = {
  accessToken: localStorage.getItem('access_token') ? localStorage.getItem('access_token') : '',
  refreshToken: localStorage.getItem('refresh_token') ? localStorage.getItem('refresh_token') : '',
  roleUser: +JSON.parse(JSON.stringify(localStorage.getItem('role'))),
  user_name: JSON.parse(JSON.stringify(localStorage.getItem('user_name'))) || '',
  cooperator_id: JSON.parse(JSON.stringify(localStorage.getItem('cooperator_id'))) || '',
  user_id: JSON.parse(JSON.stringify(localStorage.getItem('user_id'))) || '',
  kengen_code: JSON.parse(JSON.stringify(localStorage.getItem('kengen_code'))) || '',
  // 2023/11/7 Leading Win ログイン変更対応 start
  // 2024/02/19 Leading Win 作業員シフト表廃止対応 start
  business_owner_flg: +JSON.parse(JSON.stringify(localStorage.getItem('business_owner_flg'))),
  syokucyou_flg: +JSON.parse(JSON.stringify(localStorage.getItem('syokucyou_flg'))),
  // 2024/02/19 Leading Win 作業員シフト表廃止対応 end
  // 2023/11/7 Leading Win ログイン変更対応 end
};

const loginSlice = createSlice({
  name: 'login-container',
  initialState,
  reducers: {
    logout: (state) => {
      state.accessToken = '';
      state.refreshToken = '';
      state.roleUser = null;
      state.user_name = '';
      state.cooperator_id = '';
      state.error_message = '';
      state.user_id = null;
      state.kengen_code = '';
      // 2023/11/7 Leading Win ログイン変更対応 start
      state.business_owner_flg = null;
      state.syokucyou_flg = null;
      // 2023/11/7 Leading Win ログイン変更対応 end
    },
  },
  extraReducers(builder) {
    builder.addCase(signIn.pending, (state) => {
      state.accessToken = '';
      state.refreshToken = '';
      state.roleUser = null;
      state.user_name = '';
      state.cooperator_id = '';
      state.error_message = '';
      state.user_id = null;
      // 2023/11/7 Leading Win ログイン変更対応 start
      state.business_owner_flg = null;
      state.syokucyou_flg = null;
      // 2023/11/7 Leading Win ログイン変更対応 end
    });
    builder.addCase(signIn.fulfilled, (state, { payload }) => {
      state.accessToken = payload.access_token;
      state.refreshToken = payload.refresh_token;
      state.user_name = payload.user_name;
      state.roleUser = payload.role;
      state.cooperator_id = payload.cooperator_id;
      state.error_message = '';
      state.user_id = payload.user_id;
      state.kengen_code = payload?.kengen_code;
      // 2023/11/7 Leading Win ログイン変更対応 start
      state.business_owner_flg = payload?.business_owner_flg;
      state.syokucyou_flg = payload?.syokucyou_flg;
      // 2023/11/7 Leading Win ログイン変更対応 end
    });
    builder.addCase(signIn.rejected, (state, payload: any) => {
      state.accessToken = '';
      state.refreshToken = '';
      state.roleUser = null;
      state.user_name = '';
      state.cooperator_id = '';
      state.user_id = null;
      state.error_message = payload?.payload?.response?.data?.message || payload.error.message;
      // 2023/11/7 Leading Win ログイン変更対応 start
      state.business_owner_flg = null;
      state.syokucyou_flg = null;
      // 2023/11/7 Leading Win ログイン変更対応 end
    });
  },
});
export const { logout } = loginSlice.actions;

export default loginSlice.reducer;
